export const allMenus = 'allMenus';
export const canvas = 'canvas';
export const estate = 'estate';
export const internal = 'internal';
export const replication = 'replication';
export const amazons3 = 'amazons3';
export const globalSearch = 'globalSearch';
export const credentials = 'credentials';
export const identityAccess = 'identityAccess';
export const addConnector = 'addConnector';
export const timeline = 'timeline';
export const workingenvironment = 'workingenvironment';
export const connectorsettings = 'connectorsettings';
export const notification = 'notification';
export const claimOrgAdmin = 'claimOrgAdmin';
export const license ='license';
export const vendor = 'vendor';
export const local = 'local';
export const connectors = 'connectors';
export const onPrem = 'onPrem';
export const leftNav = 'leftNav';
export const support = 'support';
export const currentConnector = 'currentConnector';
export const accountmanagement = 'accountmanagement'
export const storage = 'storage';
export const homeDashboard ='homePageDashboard';
export const brownFieldHomeDashboard ='brownFieldHomeDashboard';
export const homepage ='homepage';
export const mfe = 'mfe';
export const bxpAlerts = 'bxpAlerts';
export const galleryComponents = 'galleryComponents';
export const dark = 'dark';
export const appComponents = 'appComponents';
export const navMoved = 'navMoved';
export const mfa ='mfa';
export const whatsNew = 'whatsNew';
export const galleryConfig = 'galleryConfig';
export const playground = 'playground';
export const spot = 'spot';
export const featureManager = 'featureManager';
export const splashScreen = 'splashScreen';
export const utils = 'utils';
export const storageClasses = 'storageClasses';
export const fleetManagement = 'fleetManagement';
export const storageProvisioning = 'storageProvisioning';
export const ncl = 'ncl';
export const aiByol = 'aibyol';
export const aiAssistant = 'aiAssistant';
export const notificationSettings = 'notificationSettings';
export const nclHomepage = 'nclHomepage';
export const autonomousActions = 'autonomousActions';
export const customDashboard = 'customDashboard';
export const workloadAnalyzer = 'workloadAnalyzer';
export const aiqum = 'aiqum';
export const configurations = 'configurations';
export const whatIsNewHomePage = 'whatIsNewHomePage';
export const agentCreationSidecar = 'agentCreationSidecar';
export const quickModeAgent = 'quickModeAgent';
